(() => {
  'use strict';

  const hasProtectedImage = (target) => {
    if (!(target instanceof Element)) return false;

    if (target.closest('img, picture, svg')) return true;

    let element = target;
    while (element && element !== document.documentElement) {
      if (window.getComputedStyle(element).backgroundImage !== 'none') return true;
      element = element.parentElement;
    }

    return false;
  };

  const disableNativeImageDrag = (root = document) => {
    if (root instanceof HTMLImageElement) root.draggable = false;
    root.querySelectorAll?.('img').forEach((image) => {
      image.draggable = false;
    });
  };

  document.addEventListener('contextmenu', (event) => {
    if (hasProtectedImage(event.target)) event.preventDefault();
  }, true);

  document.addEventListener('dragstart', (event) => {
    if (hasProtectedImage(event.target)) event.preventDefault();
  }, true);

  document.addEventListener('keydown', (event) => {
    const key = event.key.toLowerCase();
    const commandKey = event.ctrlKey || event.metaKey;
    const developerShortcut =
      event.key === 'F12' ||
      (commandKey && key === 'u') ||
      (commandKey && event.shiftKey && ['c', 'i', 'j'].includes(key)) ||
      (event.metaKey && event.altKey && ['c', 'i', 'j'].includes(key));

    if ((commandKey && key === 's') || developerShortcut) {
      event.preventDefault();
    }
  }, true);

  disableNativeImageDrag();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) disableNativeImageDrag(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
